import React from 'react';
import TextareaRenderer from './TextareaRenderer';
import DropdownRenderer from './DropdownRenderer';
import CheckboxRenderer from './CheckboxRenderer';
import CheckboxListRenderer from './CheckboxListRenderer';
import TextFieldRenderer from './TextFieldRenderer';

const SafetyPlanGroup = ({ fields, formData, onChange, errors = {}, readOnly = false }) => {
  const renderField = (field) => {
    const commonProps = {
      field,
      value: formData[field.field_id] || field.default_value || '',
      onChange: (value) => onChange(field.field_id, value),
      error: errors[field.field_id],
      readOnly,
    };

    switch (field.type) {
      case 'textarea':
        return <TextareaRenderer key={field.field_id} {...commonProps} />;
      case 'dropdown':
      case 'dropdown_with_freetext':
        return <DropdownRenderer key={field.field_id} {...commonProps} />;
      case 'multiselect':
      case 'multiselect_with_freetext':
        return <CheckboxListRenderer key={field.field_id} {...commonProps} />;
      case 'checkbox':
        return <CheckboxRenderer key={field.field_id} {...commonProps} />;
      case 'text':
        return <TextFieldRenderer key={field.field_id} {...commonProps} />;
      default:
        return <TextareaRenderer key={field.field_id} {...commonProps} />;
    }
  };

  return (
    <div className="border border-orange-300 rounded-lg p-4 mb-4 bg-orange-50 dark:bg-orange-900/10 dark:border-orange-700">
      <div className="flex items-center gap-2 mb-4">
        <svg className="w-5 h-5 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        <h3 className="text-lg font-semibold text-orange-800 dark:text-orange-300">Safety Plan</h3>
      </div>
      <p className="text-sm text-orange-700 dark:text-orange-400 mb-4">
        Auto-filled from chart and syncs updates back to chart with history tracking.
      </p>
      <div className="space-y-3">
        {fields.map(field => (
          <div key={field.field_id}>
            {renderField(field)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SafetyPlanGroup;
